import { useEffect, useState } from "react";
import { Note } from "../components/Note";
import { Form } from "antd";
import { API } from "../core/api";
import {
  formatAntdJalaliDate,
  onChangeProvince,
  toEnglishNumber,
} from "../core/utils";
import { useHistory, useLocation } from "react-router-dom";
import { parse, stringify } from "query-string";
import FileSaver from "file-saver";

const useEmployees = () => {
  const [form] = Form.useForm();
  const [employees, setEmployees] = useState([
    {
      pk: 5001123,
      is_active: true,
      cities: [
        {
          id: 1,
          name: "Riyadh",
        },
        {
          id: 2,
          name: "Jeddah",
        },
        {
          id: 3,
          name: "Dammam",
        },
        {
          id: 4,
          name: "Mecca",
        },
      ],
      provinces: [
        {
          id: 1,
          name: "Riyadh",
        },
        {
          id: 2,
          name: "Makkah",
        },
        {
          id: 3,
          name: "Eastern Province",
        },
      ],
      user: {
        id: 5001123,
        fullname: "Mohammed Al-Saud",
        first_name: "Mohammed",
        last_name: "Al-Saud",
        phone_number: "0501234567",
        national_id: "1234567890",
      },
      post: "Manager",
      created_at: "2023/05/21",
    },
    {
      pk: 5004567,
      is_active: true,
      cities: [
        {
          id: 5,
          name: "Madinah",
        },
      ],
      provinces: [
        {
          id: 4,
          name: "Madinah",
        },
      ],
      user: {
        id: 5004567,
        fullname: "Fatima Al-Ghamdi",
        first_name: "Fatima",
        last_name: "Al-Ghamdi",
        phone_number: "0559876543",
        national_id: "9876543210",
      },
      post: "Driver",
      created_at: "2024/11/01",
    },
    {
      pk: 5007890,
      is_active: false,
      cities: [
        {
          id: 6,
          name: "Abha",
        },
        {
          id: 7,
          name: "Taif",
        },
      ],
      provinces: [
        {
          id: 5,
          name: "Asir",
        },
        {
          id: 2,
          name: "Makkah",
        },
      ],
      user: {
        id: 5007890,
        fullname: "Ahmad Al-Zahrani",
        first_name: "Ahmad",
        last_name: "Al-Zahrani",
        phone_number: "0531122334",
        national_id: "1122334455",
      },
      post: "Driver",
      created_at: "2022/03/15",
    },
    {
      pk: 5002233,
      is_active: true,
      cities: [
        {
          id: 8,
          name: "Tabuk",
        },
      ],
      provinces: [
        {
          id: 6,
          name: "Tabuk",
        },
      ],
      user: {
        id: 5002233,
        fullname: "Khalid Al-Otaibi",
        first_name: "Khalid",
        last_name: "Al-Otaibi",
        phone_number: "0594455667",
        national_id: "4455667788",
      },
      post: "Supervisor",
      created_at: "2025/01/10",
    },
    {
      pk: 5009900,
      is_active: true,
      cities: [
        {
          id: 9,
          name: "Hail",
        },
        {
          id: 10,
          name: "Al-Qassim",
        },
      ],
      provinces: [
        {
          id: 7,
          name: "Hail",
        },
        {
          id: 8,
          name: "Al-Qassim",
        },
      ],
      user: {
        id: 5009900,
        fullname: "Nora Al-Harbi",
        first_name: "Nora",
        last_name: "Al-Harbi",
        phone_number: "0547788990",
        national_id: "7788990011",
      },
      post: "Coordinator",
      created_at: "2024/09/30",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [cities, setCities] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const params = parse(location.search);
  const [addEmployeeState, setAddEmployeeState] = useState({
    first_name: "",
    last_name: "",
    national_id: "",
    post: "",
    is_active: false,
  });
  const handleChange = (data) => {
    setAddEmployeeState({
      ...addEmployeeState,
      ...data,
    });
  };

  const getEmployees = (page) => {
    // setIsLoading(true);
    // const formItems = form.getFieldsValue();
    // const form_created_start_date =
    //   formItems.created_date.length &&
    //   formItems.created_date[0] &&
    //   typeof formItems.created_date[0] === "object"
    //     ? formatAntdJalaliDate(formItems.created_date[0])
    //     : formItems.created_date
    //     ? formItems.created_date[0]
    //     : null;
    // const form_created_end_date =
    //   formItems.created_date.length &&
    //   formItems.created_date[1] &&
    //   typeof formItems.created_date[1] === "object"
    //     ? formatAntdJalaliDate(formItems.created_date[1])
    //     : formItems.created_date
    //     ? formItems.created_date[1]
    //     : null;
    // const filters = {
    //   search,
    //   ...((page || employees?.pagination) && {
    //     page: page || employees.pagination.page,
    //   }),
    //   province_id: formItems.province_id ? Number(formItems.province_id) : null,
    //   city_id: formItems.city_id ? Number(formItems.city_id) : null,
    //   created_start_date: form_created_start_date,
    //   created_end_date: form_created_end_date,
    // };
    // history.push({
    //   pathname: "/cities-and-users/",
    //   search: stringify(filters),
    // });
    // API.get.company_employee(filters).then((response) => {
    //   if (response.success) {
    //     setEmployees(response);
    //   } else {
    //     Note.error(response.message);
    //   }
    //   setIsLoading(false);
    // });
  };

  const getEmployeesReport = () => {
    const formItems = form.getFieldsValue();
    const form_created_start_date =
      formItems.created_date.length &&
      formItems.created_date[0] &&
      typeof formItems.created_date[0] === "object"
        ? formatAntdJalaliDate(formItems.created_date[0])
        : formItems.created_date
        ? formItems.created_date[0]
        : null;

    const form_created_end_date =
      formItems.created_date.length &&
      formItems.created_date[1] &&
      typeof formItems.created_date[1] === "object"
        ? formatAntdJalaliDate(formItems.created_date[1])
        : formItems.created_date
        ? formItems.created_date[1]
        : null;

    const filters = {
      search,
      ...(employees?.pagination && {
        page: employees.pagination.page,
      }),
      province_id: formItems.province_id ? Number(formItems.province_id) : null,
      city_id: formItems.city_id ? Number(formItems.city_id) : null,
      created_start_date: form_created_start_date,
      created_end_date: form_created_end_date,
      get_report: true,
    };
    // API.get
    //   .company_employee_report(filters)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       return response.blob();
    //     } else {
    //       Note.error(response.message);
    //     }
    //   })
    //   .then((blob) => {
    //     FileSaver.saveAs(blob, `company-employees-report.xlsx`);
    //   });
  };

  const editEmployee = (
    company_employee_id,
    setIsEditModal,
    isOnSwitch,
    is_active
  ) => {
    const editEmployeeState = {
      ...addEmployeeState,
      national_id: toEnglishNumber(addEmployeeState.national_id),
    };
    if (!editEmployeeState.first_name && !isOnSwitch) {
      return Note.error("لطفا نام را وارد کنید");
    }
    if (!editEmployeeState.last_name && !isOnSwitch) {
      return Note.error("لطفا نام خانوادگی را وارد کنید");
    }
    if (!editEmployeeState.national_id && !isOnSwitch) {
      console.log(editEmployeeState, addEmployeeState.national_id);
      return Note.error("لطفا کد ملی را وارد کنید");
    }
    setIsLoading(true);
    // API.put
    //   .put_company_employee({
    //     ...editEmployeeState,
    //     company_employee_id,
    //     is_active:
    //       is_active === undefined ? editEmployeeState.is_active : is_active,
    //   })
    //   .then((response) => {
    //     if (response.success) {
    //       Note.success(response.message);
    //       form.submit();
    //       if (setIsEditModal) {
    //         setIsEditModal(false);
    //       }
    //     } else {
    //       Note.error(response.message);
    //     }
    //     setIsLoading(false);
    //   });
  };

  useEffect(() => {
    if (params.province_id && !cities.length) {
      console.log("sdfsdf");
      onChangeProvince(params.province_id, null, setCities);
    }
    // eslint-disable-next-line
  }, [params, cities]);

  const changePage = (page) => {
    setEmployees({
      ...employees,
      pagination: {
        ...employees.pagination,
        page,
      },
    });
    getEmployees(page);
  };

  useEffect(() => {
    getEmployees();
    // eslint-disable-next-line
  }, []);

  return {
    form,
    employees,
    addEmployeeState,
    handleChange,
    editEmployee,
    getEmployees,
    isLoading,
    search,
    setSearch,
    changePage,
    getEmployeesReport,
    cities,
    setCities,
  };
};

export default useEmployees;
